export default __webpack_public_path__ + "static/media/sa-relive-264.4932f889.mp4";